import ArticlesGrid from "@/components/molecules/articles-grid";
import TablesCollection from "@/components/molecules/tables-collection";
import OurServices from "@/components/organisms/our-services";
import StageHeader from "@/components/organisms/stage-header";
import { __ } from "@/lib/i18n/functions";
import { getData } from "@/lib/prismic/data";
import { getRelatedTables, resolveTableProducts } from "@/lib/prismic/inspirations";
import { getRelatedPrismicProductCategories } from "@/lib/prismic/products";
import {
  Simplify,
  TablesDocument,
  TablesDocumentDataRelatedProductsItem,
  TablesDocumentDataRelatedTablesItem,
} from "@/prismicio-types";
import { TableDocumentWithTranslation } from "@/types";
import { GroupField } from "@prismicio/client";
import { notFound } from "next/navigation";
import { use } from "react";

const Table = ({ resolution }: TemplateProps) => {
  const document = use(getData(resolution)) as TablesDocument;

  if (!document || !document.data) return notFound();

  const { title, featured_image, description } = document.data;

  let relatedTablesDoc: GroupField<Simplify<TablesDocumentDataRelatedTablesItem>>;
  let relatedProductsDoc: GroupField<Simplify<TablesDocumentDataRelatedProductsItem>>;

  relatedTablesDoc = document.data.related_tables || [];
  relatedProductsDoc = document.data.related_products;

  if (resolution.locale !== "fr") {
    const { translation } = document as TableDocumentWithTranslation;
    relatedTablesDoc = translation.data.related_tables || [];
    relatedProductsDoc = translation.data.related_products;
  }

  const relatedTables = use(getRelatedTables(relatedTablesDoc, resolution.locale));
  const tableProducts = use(resolveTableProducts(relatedProductsDoc, resolution.locale));
  const tableProductsCategories = use(getRelatedPrismicProductCategories(tableProducts, resolution.locale));

  return (
    <>
      <StageHeader
        locale={resolution.locale}
        className="container my-6 md:my-4 max-md:[&_h1]:mt-4 max-md:[&_h1]:text-center"
        orientationOnMobile="center"
        hideDescriptionOnMobile
        isDescriptionCentered={false}
        hideImageOnMobile={false}
        title={title}
        description={description}
        imageAlt={featured_image.alt || ""}
        imageUrl={featured_image.url || ""}
      />
      {tableProducts && tableProducts.length >= 1 && (
        <ArticlesGrid
          headline={__("This pack contains", resolution.locale)}
          variant="pack"
          products={tableProducts || []}
          locale={resolution.locale}
          collectionCategories={tableProductsCategories || []}
        />
      )}
      <TablesCollection
        tables={relatedTables}
        locale={resolution.locale}
        variant="table"
        className="flex flex-col min-[925px]:grid"
      />
      <OurServices locale={resolution.locale} className="max-md:hidden" />
    </>
  );
};

export default Table;
